import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, useMessage } from '../global-components/src';

interface ModeratorOrBrownRouteProps {
    children: React.ReactNode;
}

const ModeratorOrBrownRoute: React.FC<ModeratorOrBrownRouteProps> = ({ children }) => {
    const { isAuthenticated, user } = useAuth();
    const { setMessage } = useMessage();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    const canAccessModerator = Boolean(user?.position) || Boolean(user?.id && user.id < 5);
    const hasBrownStamp = user?.stamps?.includes('brown') ?? false;

    if (!canAccessModerator && !hasBrownStamp) {
        setMessage('Acesso negado', 'error');
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default ModeratorOrBrownRoute;
